import type { ExchangeBetslipPreferences, SportsbookBetslipPreferences } from "../../../contract";

export const BETSLIP__SBK_PREFERENCES_RECEIVED = "BETSLIP/SBK_PREFERENCES_RECEIVED";
export const BETSLIP__EXC_PREFERENCES_RECEIVED = "BETSLIP/EXC_PREFERENCES_RECEIVED";

export type SportsbookPreferencesReceivedAction = {
  type: typeof BETSLIP__SBK_PREFERENCES_RECEIVED;
  payload: SportsbookBetslipPreferences;
};

export type ExchangePreferencesReceivedAction = {
  type: typeof BETSLIP__EXC_PREFERENCES_RECEIVED;
  payload: ExchangeBetslipPreferences;
};

export const UI__BETSLIP_SBK_ACCEPT_ODDS_MOVEMENT_TOGGLE = "UI/BETSLIP_SBK_ACCEPT_ODDS_MOVEMENT_TOGGLE";

export type BetslipSportsbookAcceptOddsMovementToggleAction = {
  type: typeof UI__BETSLIP_SBK_ACCEPT_ODDS_MOVEMENT_TOGGLE;
  payload: { enabled: boolean };
};
